// The left menu in App admin's look: groups with a header you can fold, MenuLinks with their counters (campaigns
// waiting for approval, people on the suppression list). Last, Help: the workflow manual, opened in a new tab.
import { useState } from 'react'
import { BookOpen, ChevronDown, ExternalLink } from 'lucide-react'
import { useOverview } from '@/features/overview'
import { HELP_LINKS, MENU } from '../menus'
import { MenuLink } from './MenuLink'

export function SidebarMenu() {
  const overview = useOverview()
  const [folded, setFolded] = useState<string[]>([])
  const counts = {
    approvals:
      (overview.data?.waiting_approval ?? 0) +
      (overview.data?.vendor_changes_waiting ?? 0) +
      (overview.data?.voice_messages_waiting ?? 0),
    suppression: overview.data?.suppressed ?? 0,
  }
  const toggle = (title: string) =>
    setFolded((now) => (now.includes(title) ? now.filter((t) => t !== title) : [...now, title]))
  const header = (title: string) => (
    <button
      type="button"
      className="flex w-full items-center justify-between rounded px-2 py-1.5 text-2xs font-bold uppercase tracking-wider text-muted hover:bg-slate-100 dark:hover:bg-slate-800"
      onClick={() => toggle(title)}
      aria-expanded={!folded.includes(title)}
    >
      <span>{title}</span>
      <ChevronDown size={12} className={folded.includes(title) ? '' : 'rotate-180'} />
    </button>
  )
  return (
    <nav aria-label="Main" className="flex-1 space-y-2 overflow-y-auto px-2 py-3">
      {MENU.map((group) => (
        <div key={group.title || 'home'}>
          {group.title && header(group.title)}
          {!folded.includes(group.title) && (
            <div className="mt-1 space-y-0.5">
              {group.items.map((item) => (
                <MenuLink key={item.path} item={item} count={item.badge ? counts[item.badge] : 0} />
              ))}
            </div>
          )}
        </div>
      ))}
      <div>
        {header('Help')}
        {!folded.includes('Help') && (
          <div className="mt-1 space-y-0.5">
            {HELP_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="nav-item"
                data-testid="menu-manual"
              >
                <BookOpen size={15} className="shrink-0" />
                <span>{link.label}</span>
                <ExternalLink size={12} className="ml-auto text-muted" aria-label="opens in a new tab" />
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  )
}
